export const appSettingFirstAppVisit = 'firstWebAppVisit'
